import React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, MapDispatchToProps } from 'react-redux';

import {
  updateLoginAfterIdle,
  resetAllAfterLogout,
} from 'actions/authenticate';
import { WeaverApiClientInstance } from 'api/weaverApiClientInstance';
import { requestLogout } from 'services/authenticate';
import { IDLE_TIMEOUT_IN_SECONDS } from 'utils/constants';

import PearIdle from './PearIdle';

const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];
interface IDispatchProps {
  resetAllAfterLogout: () => void;
  updateLoginAfterIdle: (param: boolean) => void;
}

type Props = IDispatchProps;

const idleTimeoutMilliseconds = IDLE_TIMEOUT_IN_SECONDS * 1000;

const IdleLogout = (props: Props) => {
  const handleOnChange = async ({ idle }: { idle: boolean }) => {
    if (idle) {
      await requestLogout(true);
      WeaverApiClientInstance.reset();
      props.resetAllAfterLogout();
      props.updateLoginAfterIdle(true);
    }
  };

  return (
    // @ts-ignore
    <PearIdle
      timeout={idleTimeoutMilliseconds}
      onChange={handleOnChange}
      render={() => null}
      events={EVENTS}
    />
  );
};

const mapDispatchToProps: MapDispatchToProps<IDispatchProps, {}> = (
  dispatch: Dispatch,
) =>
  bindActionCreators(
    {
      updateLoginAfterIdle,
      resetAllAfterLogout,
    },
    dispatch,
  );

export default connect(null, mapDispatchToProps)(IdleLogout);
